exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datepicker.invalid + input.input {\n  border-color: #dc8d99 !important;\n  background: #fff7f8 !important;\n  color: #d85030 !important;\n}", ""]);

// exports
